import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import Forms from './components/Forms';

const FiliaisOuvidoriaCadastro = ({ isReadOnly = false, id: propId, hideHeader = false }) => {
  const { id: paramId } = useParams();
  const id = propId || paramId;
  const isEditing = !!id && !isReadOnly;
  const isViewing = isReadOnly;

  return (
    <Container fluid>
      {!hideHeader && (
        <Row>
          <Col md={12}>
            <PageHeader
              title=""
              routeSegments={[
                { name: 'Inicio' },
                { name: 'Filiais da Ouvidoria', route: '/pages/filiaisouvidoria' },
                {
                  name: isViewing
                    ? 'Detalhes da Filial'
                    : isEditing
                      ? 'Editar Filial'
                      : 'Nova Filial',
                },
              ]}
            />
          </Col>
        </Row>
      )}

      <Row>
        <Col md={12}>
          <Forms isReadOnly={isReadOnly} />
        </Col>
      </Row>
    </Container>
  );
};

export default FiliaisOuvidoriaCadastro;
